import { Card, CardContent } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { emailNotificationsTests } from "./testDefinitions";

/**
 * Email Notification Section - Tests for cron job and owner notifications
 * CRITICAL: Owner must be notified when bookings come in!
 */
export const EmailNotificationSection = ({ testResults }) => {
  return (
    <Card className="shadow-none mb-4 border-orange-200">
      <CardContent className="pt-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded font-medium">CRITICAL</span>
          <span className="text-xs text-gray-500">Cron Job & Owner Notification Tests</span>
        </div>
        <TestSubsection 
          title="📧 Email & Notification System"
          tests={emailNotificationsTests}
          results={testResults.emailNotifications}
        />
      </CardContent>
    </Card>
  );
};

export default EmailNotificationSection;
